import { render, staticRenderFns } from "./error-monitor-event-tree.component.vue?vue&type=template&id=5bca8863&scoped=true&"
import script from "./error-monitor-event-tree.component.vue?vue&type=script&lang=ts&"
export * from "./error-monitor-event-tree.component.vue?vue&type=script&lang=ts&"
import style0 from "./error-monitor-event-tree.component.vue?vue&type=style&index=0&id=5bca8863&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca8863",
  null
  
)

export default component.exports